import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

import * as Styled from './styled'
import { useResize } from './useResize'
import CanvasContent from './CanvasContent'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { useResponsive } from 'hooks/useResponsive'
import { formatTime } from 'utils/time-formatter'
import { useCanvasUpdates } from './useCanvasUpdates'

const Canvas: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const canvasRef = useRef<HTMLDivElement>(null)
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  const projectDuration = useSelector(projectDataSelectors.duration)
  const hasMediaItems = useSelector(projectDataSelectors.hasMediaItems)

  const { aspectRatio } = useSelector(projectDataSelectors.defaultDimensions)

  useResize(containerRef, canvasRef, aspectRatio)
  useCanvasUpdates()

  return (
    <Styled.CanvasContainer>
      <Styled.ResizableWrapper ref={containerRef}>
        <Styled.CanvasWrapper
          ref={canvasRef}
          $aspectRatio={aspectRatio}
          $isBlankCanvas={!hasMediaItems}
        >
          <CanvasContent canvasWrapperEl={canvasRef.current} />
        </Styled.CanvasWrapper>
      </Styled.ResizableWrapper>
      {isMobile && (
        <Styled.ProjectDuration>
          {formatTime(projectDuration)}
        </Styled.ProjectDuration>
      )}
    </Styled.CanvasContainer>
  )
}

export default Canvas
